var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-19a2f005] {\n  width: 70%;\n  height: 34px;\n  padding-left: 40px;\n  font-size: 16px;\n  background-color: #fff;\n  line-height: 30px;\n  background: url(" + escape(require("../../../assets/ios-search-strong.png")) + ") #F2F2F2 no-repeat left 10px center;\n  background-size: 23px 23px;\n  border: 1px solid #F1F1F1;\n  color: #3C3C3C;\n  border-radius: 30px;\n  left: 15%;\n  top: 3px;\n  position: fixed;\n  z-index: 1;\n}\n", ""]);

// exports
